$(function(){
    
  $('.ht-faq').click(function(e) {
    $(this).toggleClass('active');
  });
  
  $('.nutritional-link').click(function(e) {
    $('.ht-modal').toggleClass('active');
    $('body').toggleClass('no-scroll');
  });
  
  $('.ht-close-modal').click(function(e) {
    $('.ht-modal').toggleClass('active');
    $('body').toggleClass('no-scroll');
  });
  
  
  
  	// animate in view


    var $animation_elements = $('.animate');
    var $animation_elements_mobile = $('.animate-mobile');

    var checkInView = function() {

      window.requestAnimationFrame(function() {

        var winTop = $(window).scrollTop();
        var winHeight = $(window).outerHeight();
        var winBot = (winTop + winHeight);


            $.each($animation_elements, function() {
                var $element = $(this);
                var element_height = $element.outerHeight();
                var element_top_position = $element.offset().top;
                var element_bottom_position = (element_top_position + element_height);

                //check to see if this current container is within viewport
                if ((element_bottom_position >= (winTop - 200)) &&
                    (element_top_position <= (winBot))) {
                    $element.addClass('in-view');
                } else {
                    $element.removeClass('in-view');
                }
            });

            $.each($animation_elements_mobile, function() {
                var $element = $(this);
                var element_height = $element.outerHeight();
                var element_top_position = $element.offset().top;
                var element_bottom_position = (element_top_position + element_height);

                //check to see if this current container is within viewport
                if ((element_bottom_position >= (winTop - 200)) &&
                    (element_top_position <= (winBot))) {
                    $element.addClass('in-view');
                } else {
                    $element.removeClass('in-view');
                }
            });
        
        	$.each($('footer'), function() {
                var $element = $(this);
                var element_height = $element.outerHeight();
                var element_top_position = $element.offset().top;
                var element_bottom_position = (element_top_position + element_height);

                //check to see if this current container is within viewport
                if ((element_bottom_position >= (winTop - 200)) &&
                    (element_top_position <= (winBot))) {
                    $('.product-form').addClass('hide');
                } else {
                    $('.product-form').removeClass('hide');
                }
            });

            
        }.bind(this)); // rAF
    };

    checkInView();
  
  	$(window).scroll(function(event){
        checkInView();
    });

});

$(window).load(function(){
  $('.ht-hero__image').removeClass('inactive');
});